import { Loader2, AlertTriangle, CheckCircle } from 'lucide-react';

export default function ResetProgressModal({ isVisible, step, totalSteps, message, error, isComplete }) {
  if (!isVisible) return null;

  const progress = (step / totalSteps) * 100;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" dir="rtl">
      <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 rounded-2xl p-8 max-w-sm w-full text-center">
        <div className="flex justify-center mb-6">
          {error ? (
            <div className="w-16 h-16 bg-red-500/20 rounded-2xl flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-red-400" />
            </div>
          ) : isComplete ? (
            <div className="w-16 h-16 bg-emerald-500/20 rounded-2xl flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-emerald-400" />
            </div>
          ) : (
            <div className="w-16 h-16 bg-blue-500/20 rounded-2xl flex items-center justify-center">
              <Loader2 className="w-8 h-8 text-blue-400 animate-spin" />
            </div>
          )}
        </div>

        <h2 className="text-xl font-black text-white mb-2">
          {error ? 'حدث خطأ' : isComplete ? 'اكتملت بنجاح!' : 'جاري إعادة التهيئة'}
        </h2>

        {!error && !isComplete && (
          <>
            <p className="text-white/50 text-sm mb-6">{message}</p>
            
            <div className="w-full bg-white/10 rounded-full h-2 mb-4 overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-blue-400 to-blue-600 transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
            
            <p className="text-white/40 text-xs mb-6">
              {step} / {totalSteps}
            </p>
            
            <p className="text-amber-300 text-xs">⚠️ لا تغلق التطبيق</p>
          </>
        )}

        {isComplete && (
          <p className="text-emerald-300 text-sm">جاري إعادة التحميل...</p>
        )}

        {error && (
          <div className="text-left">
            <p className="text-red-300 text-sm mb-2">{error}</p>
            <p className="text-white/40 text-xs">يمكنك إعادة المحاولة من صفحة الإعدادات الإدارية</p>
          </div>
        )}
      </div>
    </div>
  );
}